import _ from 'lodash';
import * as types from '../constants/ActionTypes';

const initialState = {
	list: [],
	pagination: null,
	isExtractingXml: false,
	isFetchingXml: false,
	isFetching: false,
	isSaving: false,
	isSaved: false,
	error: null,
	xmlParseWarnings: [],
	parsingXmlNames: [],
	extractedCorporations: [],
	forceRunningFeedIds: {},
	forceRunningPhoenixFeedIds: {},
	deletingFeedIds: {},
};

export default function feeds(state = initialState, action) {
	switch (action.type) {
		case types.CLEAR_FEED_ERROR:
			return {
				...state,
				error: null,
			};

		case types.SUBMIT_ADD_FEED:
			return {
				...state,
				isSaving: true,
				isSaved: false,
			};

		case types.RESOLVE_ADD_FEED: {
			// Add the new feed to the list
			let list = _.concat(action.feed, state.list);

			return {
				...state,
				list,
				isSaving: false,
				isSaved: true,
			};
		}

		case types.RESOLVE_ADD_FEED_ERROR:
			return {
				...state,
				isSaving: false,
				error: action.error,
			};

		case types.SUBMIT_EDIT_FEED:
			return {
				...state,
				isSaving: true,
				isSaved: false,
			};

		case types.RESOLVE_EDIT_FEED: {
			// Update the feed in the list
			let list = _.clone(state.list).map(feed => {
				// Return the updated feed if it matches, otherwise
				// return the existing feed data
				if (feed.id === action.feed.id) {
					return action.feed;
				} else {
					return feed;
				}
			});

			return {
				...state,
				list,
				isSaving: false,
				isSaved: true,
			};
		}

		case types.RESOLVE_EDIT_FEED_ERROR:
			return {
				...state,
				isSaving: false,
				error: action.error,
			};

		case types.SUBMIT_FETCH_FEED_XML:
			return {
				...state,
				isFetchingXml: true,
				error: null,
			};

		case types.RESOLVE_FETCH_FEED_XML:
			return {
				...state,
				isFetchingXml: false,
				error: null,
			};

		case types.RESOLVE_FETCH_FEED_XML_ERROR:
			return {
				...state,
				isFetchingXml: false,
				error: action.error,
			};

		case types.SUBMIT_EXTRACT_FEED_XML:
			return {
				...state,
				isExtractingXml: true,
				error: null,
			};

		case types.RESOLVE_EXTRACT_FEED_XML:
			return {
				...state,
				isExtractingXml: false,
				error: null,
			};

		case types.RESOLVE_EXTRACT_FEED_XML_ERROR:
			return {
				...state,
				isExtractingXml: false,
				error: action.error,
			};

		case types.SUBMIT_PARSE_FEED_XML:
			return {
				...state,
				parsingXmlNames: [...state.parsingXmlNames, action.name],
			};

		case types.RESOLVE_PARSE_FEED_XML:
			return {
				...state,
				parsingXmlNames: state.parsingXmlNames.filter(name => name !== action.name),
				extractedCorporations: [...action.data, ...state.extractedCorporations],
			};

		case types.RESOLVE_PARSE_FEED_XML_ERROR:
			return {
				...state,
				parsingXmlNames: state.parsingXmlNames.filter(name => name !== action.name),
				error: action.error,
			};

		case types.RECEIVE_PARSE_FEED_XML_WARNING:
			return {
				...state,
				parsingXmlNames: state.parsingXmlNames.filter(name => name !== action.name),
				xmlParseWarnings: [...state.xmlParseWarnings, action.warning],
			};

		case types.CLEAR_PARSE_FEED_XML_WARNING:
			return {
				...state,
				xmlParseWarnings: _.filter(
					state.xmlParseWarnings,
					warning => warning.id !== action.warningId,
				),
			};

		case types.SUBMIT_FORCE_FEED: {
			// Add the feed ids to the force running feed ids
			let forceRunningFeedIds = _.clone(state.forceRunningFeedIds);
			forceRunningFeedIds[action.feed.id] = true;

			return {
				...state,
				forceRunningFeedIds,
			};
		}

		case types.RESOLVE_FORCE_FEED: {
			// Remove the feed from the force running ids
			let forceRunningFeedIds = _.clone(state.forceRunningFeedIds);
			delete forceRunningFeedIds[action.feed.id];

			return {
				...state,
				forceRunningFeedIds,
			};
		}

		case types.RESOLVE_FORCE_FEED_ERROR: {
			// Remove the feed from the force running ids
			let forceRunningFeedIds = _.clone(state.forceRunningFeedIds);
			delete forceRunningFeedIds[action.feed.id];

			return {
				...state,
				forceRunningFeedIds,
				error: action.error,
			};
		}

		case types.SUBMIT_DELETE_FEED:
			return {
				...state,
				deletingFeedIds: {
					...state.deletingFeedIds,
					[action.feedId]: true,
				},
			};

		case types.RESOLVE_DELETE_FEED:
			return {
				...state,
				list: _.reject(state.list, { id: action.feedId }),
				deletingFeedIds: _.omit(state.deletingFeedIds, action.feedId),
			};

		case types.RESOLVE_DELETE_FEED_ERROR:
			return {
				...state,
				deletingFeedIds: _.omit(state.deletingFeedIds, action.feedId),
			};

		case types.RESOLVE_CANCEL_FEED_LOAD:
			return {
				...state,
				error: null,
			};

		case types.CLEAR_FEED_XML_STATE:
			return {
				...state,
				parsingXmlNames: [],
				isFetchingXml: false,
				isExtractingXml: false,
				xmlParseWarnings: [],
				extractedCorporations: [],
				error: null,
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/reducers/feeds.js